import { IUser } from "../../Interfaces/responseTypes";

export const useAvatarHooks = (user:IUser)=>{
    const {username,first_name,last_name} = user;
    const circleText = first_name && last_name
    ? `${first_name[0]}${last_name[0]}`.toUpperCase()
    : username.slice(0, 2).toUpperCase();

    const avatarText = first_name && last_name
    ? `${first_name} ${last_name}`
    : username;

    return {
        circleText,
        avatarText
    }

}